import React, { useEffect } from "react";
const { useState } = require("react")


const Tag = ({tag, onChange}) => {
  return <div key={`tag-${tag.key}`} className="form-check" style={{width:'15em'}}>
    <input
      className="form-check-input"
      type="checkbox"
      name={tag.key}
      value={tag.key}
      onChange={(e) => onChange(tag, e.target.checked)}
    />
    <label className="form-check-label align-middle" htmlFor={tag}>
      {tag.label}
    </label>
  </div>;
};

const TagFilter = ({availableTags = [], onChange}) => {
  const [selectedTags, setSelectedTags] = useState([]);

  const handleChange = (tag, checked)=>{
    if ( checked ) {
      setSelectedTags( [...selectedTags, tag]);
    } else {
      setSelectedTags( tags=> tags.filter(t=>t!==tag));
    }
  };

  useEffect(()=>{
      onChange(selectedTags);
  }, [selectedTags]);

  return availableTags.length > 0 ? availableTags.map(tag => <Tag tag={tag} onChange={handleChange} />) : null;
};


export default TagFilter;
